export default "__VITE_ASSET__ZodfVaYW__"